import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AppContext } from "../context/AppContext";

const AdminAuth = ({ children }) => {
  //   const isAuth = useSelector((store) => store.auth.token);
  const { isAdmin } = useContext(AppContext);
  const { pathname } = useLocation();
  if (isAdmin) {
    return children;
  } else {
    return <Navigate to="/login" state={{ from: pathname }} replace />;
  }
};

export default AdminAuth;
